import { Link } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import Person from 'services/data/person';


export default function PersonLink({ person, className, children }) {
  if (!person || _.isEmpty(person)) return null;

  return (
    <Link to={`/people/${person.id}`} className={classNames('person-link', className)}>
      {children || Person.fullName(person)}
    </Link>
  );
}

PersonLink.propTypes = {
  person: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};
